import { render, staticRenderFns } from "./orderAwardDetail.vue?vue&type=template&id=70d097c3&scoped=true&"
import script from "./orderAwardDetail.vue?vue&type=script&lang=js&"
export * from "./orderAwardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d097c3",
  null
  
)

export default component.exports